module.exports = __webpack_public_path__ + "static/media/clinic2.a86dbfba.png";